import { render, staticRenderFns } from "./ReviewListPage.vue?vue&type=template&id=3233558c&scoped=true"
import script from "./ReviewListPage.vue?vue&type=script&lang=js"
export * from "./ReviewListPage.vue?vue&type=script&lang=js"
import style0 from "./ReviewListPage.vue?vue&type=style&index=0&id=3233558c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3233558c",
  null
  
)

export default component.exports